<template>
  <div id="auth-container" v-loading.fullscreen.lock="loading">
    <el-row class="main-row" align="middle" type="flex" :gutter="32">
      <el-col :span="8">
        <img
          class="logo"
          src="../assets/images/doc-flow-logo.svg"
          alt="DocFlow"
        />
      </el-col>
      <el-col :span="16">
        <el-row class="form-row">
          <el-col>
            <el-input placeholder="Username" v-model="form.username">
            </el-input>
          </el-col>
        </el-row>
        <el-row class="form-row">
          <el-col>
            <el-input
              placeholder="Password"
              v-model="form.password"
              show-password
              @keyup.enter.native="onSignIn"
            >
            </el-input>
          </el-col>
        </el-row>
        <el-row class="form-row">
          <el-col>
            <el-button type="primary" style="width: 100%" @click="onSignIn"
              >Sign in
            </el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Authentication",
  data() {
    return {
      loading: false,
      form: {
        username: "",
        password: "",
      },
    };
  },
  methods: {
    onSignIn() {
      if (this.loading) return;
      let { username, password } = this.form;
      this.loading = true;
      axios
        .post(
          `${process.env.VUE_APP_BASE_API_URL}oauth/token?username=${username}&password=${password}&grant_type=password`,
          null,
          {
            headers: {
              Authorization: `Basic ${process.env.VUE_APP_BASIC_AUTH_TOKEN}`,
            },
          }
        )
        .then(({ data }) => {
          this.loading = false;
          this.$store.commit("login", data);
          this.$router.replace({ name: "Main" });
        })
        .catch(() => {
          this.loading = false;
          this.$message({
            message: "Incorrect username or password",
            type: "warning",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
#auth-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.main-row {
  width: 460px;
}

.form-row {
  margin-bottom: 8px;
}

.logo {
  width: 128px;
}
</style>
